import { BiLoaderAlt } from "react-icons/bi";
import { StyledLoading } from "./styles";

export const Loading = () => {
  return (
    <StyledLoading>
      <BiLoaderAlt></BiLoaderAlt>
    </StyledLoading>
  );
};
